import React from 'react';
import "./report.css"
import Button from "../button/button-component";
import FooterLink from "../footer-link/footer-link-component";

const keyStyle = {
  marginRight: '5px',
  fontWeight: '400'
};

const Report = (
  {
    company,
    report_url,
    title
  }
) => {
  return (
    <div className="report_component">

      <div className="report_component__item">
         <span style={{
            fontWeight: '400',
            fontSize: '20px'
         }}>{ title }</span>
      </div>

      <div className="report_component__item">
        <span style={keyStyle}>Company:</span>
        <span>{ company }</span>
      </div>

      <div className="report_component__item">
        <span style={keyStyle}>URL:</span>
        <span>{ report_url }</span>
      </div>

      <div className="report_component__item" style={{flexDirection: 'row-reverse'}}>
        <FooterLink
          name="Go"
          link={`/report?reportUrl=${report_url}`}
        />
      </div>

    </div>
  )
};

export default Report;


// WEBPACK FOOTER //
// ./src/components/report/report-component.js